const now = () => Date.now();

export const readCache = (entry) => {
  if (!entry) return null;
  if (entry.expiresAt > now()) return entry.data;
  return null;
};

export const writeCache = (entry, data, ttlMs) => {
  entry.data = data;
  entry.expiresAt = now() + ttlMs;
};

export const readMapCache = (map, key) => {
  const entry = map.get(key);
  if (!entry) return null;
  if (entry.expiresAt > now()) return entry.data;
  map.delete(key);
  return null;
};

export const writeMapCache = (map, key, data, ttlMs) => {
  map.set(key, { data, expiresAt: now() + ttlMs });
};
